"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingCircle = function LoadingCircle(_ref) {
  var baseUrl = _ref.baseUrl;


  return _react2.default.createElement(
    "div",
    { className: "circlesWrapper" },
    _react2.default.createElement(
      "div",
      { className: "circleProgress-1" },
      _react2.default.createElement("div", { className: "pie spinner" }),
      _react2.default.createElement("div", { className: "pie filler" }),
      _react2.default.createElement("div", { className: "mask" })
    ),
    _react2.default.createElement(
      "div",
      { className: "circleProgress-2" },
      _react2.default.createElement("div", { className: "pie spinner" }),
      _react2.default.createElement("div", { className: "pie filler" }),
      _react2.default.createElement("div", { className: "mask" })
    ),
    _react2.default.createElement(
      "div",
      { className: "circleProgress-3" },
      _react2.default.createElement("div", { className: "pie spinner" }),
      _react2.default.createElement("div", { className: "pie filler" }),
      _react2.default.createElement("div", { className: "mask" })
    ),
    _react2.default.createElement(
      "div",
      { className: "circleProgress-4" },
      _react2.default.createElement("div", { className: "pie spinner" }),
      _react2.default.createElement("div", { className: "pie filler" }),
      _react2.default.createElement("div", { className: "mask" })
    )
  );
};

exports.default = LoadingCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Util/LoadingCircle.js
// module id = 807
// module chunks = 0